import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { PortalInvariant } from '@src/app/model/portal-invariant';
import { Events } from '@ess/jg-rule-executor';

export class RuleData {
  ruleId: string;
  ruleCode: string;
  additionalFields?: ToJsonInputTranslatable;
  correctionCode?: string;

  constructor(ruleId: string, ruleCode: string, additionalFields?: ToJsonInputTranslatable, correctionCode?: string) {
    this.ruleId = ruleId;
    this.ruleCode = ruleCode;
    this.additionalFields = additionalFields;
    this.correctionCode = correctionCode;
  }

  equals(obj: any) {
    if (obj instanceof RuleData) {
      return (obj.ruleCode === this.ruleCode)
        && (obj.ruleId === this.ruleId)
        && (obj.correctionCode === this.correctionCode)
        && (obj.additionalFields === this.additionalFields);
    } else {
      return false;
    }
  }

  static fromInvariant(input: PortalInvariant, additionalFields?: PortalInvariant, includeCorrection = true): RuleData {
    return new RuleData(
      input.id.toString(),
      input.rule,
      additionalFields || input,
      includeCorrection ? input.correction : undefined
    );
  }
}

export function createRuleListFromInvariants(
  input: PortalInvariant[]
): RuleData[] {
  if (input.length) {
    return input.map(inv => RuleData.fromInvariant(inv));
  } else {
    return [];
  }
}

export function createRuleListFromEvents(
  input: Events
): RuleData[] {
  return [
    new RuleData('onAttach', input.onAttach),
    new RuleData('onDelete', input.onDelete),
    new RuleData('onCreated', input.onCreated),
    new RuleData('onChange', input.onChange),
  ];
}
